import React from "react";
import TitleFormat from "../components/TitleFormat";
import ItEnvironmentContent from "../components/ItEnvironmentContent";
import { useTranslation } from "react-i18next";
import { Seo } from "../components/Seo";

const ItEnvironment = () => {
  const { t } = useTranslation();
  return (
    <>
      <Seo title={t("consulting.environment.seo.title")} description={t("consulting.environment.seo.des")} path="eco-planning/environment-simulation" />
      <TitleFormat text={t("consulting.environment.title")} />
      <ItEnvironmentContent />
    </>
  );
};

export default ItEnvironment;
